import { jsx as _jsx } from "react/jsx-runtime";
import { RelayIndicator } from 'console/shared/components/panels/heating-circuits/heating-circuit/components/status-line/components/icons/relay';
import { ThreewayTapIndicator } from 'console/shared/components/panels/heating-circuits/heating-circuit/components/status-line/components/icons/threeway-tap';
import { PumpIndicator } from 'console/shared/components/panels/heating-circuits/heating-circuit/components/status-line/components/icons/pump';
import { SocketsIcon } from 'console/shared/components/fields/icon/icons/socket';
import * as classnames from 'classnames';
import { CustomIcon } from 'shared/components/icon/custom';
import { LoadedIcon } from 'shared/components/panels/custom-controls/custom-controls-card/components/loaded-icon';
export const IconForWebElement = (props) => {
    const { icon, active, ...rest } = props;
    if (typeof icon === 'string') {
        return _jsx(LoadedIcon, { icon: icon, active: active, ...rest });
    }
    if (icon.id == 300) {
        return _jsx(SocketsIcon, { ...rest });
    }
    if (icon.id == 302) {
        return _jsx(PumpIndicator, { ...rest, active: active });
    }
    if (icon.id == 303) {
        return _jsx(RelayIndicator, { ...rest, active: active });
    }
    if (icon.id == 304) {
        const tap_props = active
            ? {
                fill: '#c4443b',
                fillOpacity: '0.553',
                status: 'Открыт',
            }
            : { fill: '#7d9dff', fillOpacity: '0.822', status: 'Закрыт' };
        return _jsx(ThreewayTapIndicator, { ...rest, active: active, ...tap_props });
    }
    return (_jsx(CustomIcon, { ...rest, Icon: icon.render, className: classnames('', {
            blink: active,
        }) }));
};
